import React, { useEffect, useRef, useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import * as API from '../../framework/API/api';
import { useTranslation } from '../../locale/useTranslation';
import { ENTITYNAME } from '../../framework/constant/constant';
import { toast } from 'react-toastify';
import { EditPageHeader } from '../../components/EditPageHeader';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { utility } from '../../framework/utility/utilityProvider';
import { BUDGET_STATUS, META_STATUS_TYPE } from './SocialMediaConstant';
import { SocialMediaHelper } from './SocialMediaHelper';
import SMCampaignEditForm from './SMCampaignEditForm';
import PublishOrUnPublishForm from './PublishOrUnPublishForm';
import PublishOrUnPublishStatusCard from './PublishOrUnPublishStatusCard';
import SMInsightsForm from './SMInsightsForm';
import { MenuCommandCell } from '../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import { TextWithIconCell } from '../../framework/forms/helpercomponents/CustomGridCells/TextWithIconCell';

const SMBudgetEditForm = () => {

  const lang = useTranslation();

  const { id } = useParams();
  const navigate = useNavigate();

  const blankDataItem = {
    description: '',
    clientPONo: '',
    agency: '',
    client: '',
    orderDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().endOf('month').format('YYYY-MM-DD'),
    currency: {},
    targetAmount: 0,
    agencyComission: 0,
    status: {},
    Archive: false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [currencies, setCurrencies] = useState([])
  const [status, setStatus] = useState([])
  const [campaignData, setCampaignData] = useState([])
  const [showCampaignPopup, setShowCampaignPopup] = useState({ show: false, item: {} });
  const [showPublishOrUnPublishPopup, setShowPublishOrUnPublishPopup] = useState({ show: false, item: {}, isPublished: false });
  const [agencies, setAgencies] = useState([]);
  const [clients, setClients] = useState([]);
  const oldCampaignRef = useRef(null);
  const [showInsightPopup, setShowInsightPopup] = useState({ show: false, item: {} })
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadCombo();
    if (id && id != 0) loadData();
  }, [])

  const loadCombo = async () => {
    let currencyRes = await API.getDataLookup(ENTITYNAME.Currency);
    setCurrencies(currencyRes.data);
    const statusRes = Object.keys(BUDGET_STATUS).map(key => ({
      _id: BUDGET_STATUS[key],
      description: key
    }));
    setStatus(statusRes);
    let agenciesRes = await API.getDataLookup(ENTITYNAME.Agency, { query: ['Archive', '!=', true] });
    setAgencies(agenciesRes.data);
    let clientsRes = await API.getDataLookup(ENTITYNAME.Client, { query: ['Archive', '!=', true] });
    setClients(clientsRes.data);
    if (!id || id == 0) setDataItem({ ...dataItem, currency: utility.getDefaultItem(currencyRes.data), status: utility.getDefaultItem(statusRes) });
  }

  const onInsightClick = (item) => {
    setShowInsightPopup({ show: true, item: item })
  }

  const loadData = async (_id = id) => {

    const res = await API.getBudgetData(_id);
    console.log(res);

    if (!res.success) {
      toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    let budgetData = res?.data?.budgetData ?? {};
    setDataItem({
      ...budgetData,
      description: budgetData?.description ?? '',
      clientPONo: budgetData?.clientPONo ?? '',
      agency: budgetData?.agency ?? {},
      client: budgetData?.client ?? {},
      orderDate: budgetData?.orderDate ? moment(budgetData?.orderDate).format('YYYY-MM-DD') : '',
      fromDate: budgetData?.fromDate ? moment(budgetData?.fromDate).format('YYYY-MM-DD') : '',
      toDate: budgetData?.toDate ? moment(budgetData?.toDate).format('YYYY-MM-DD') : '',
      currency: budgetData?.currency ? {
        _id: budgetData?.currency?._id,
        Description: budgetData?.currency?.Description
      } : {},
      targetAmount: budgetData?.targetAmount ?? '',
      agencyComission: budgetData?.agencyComission ?? '',
      status: budgetData?.status ? {
        _id: budgetData?.status,
        description: budgetData?.status
      } : {},
      Archive: budgetData?.Archive ?? false
    });
    setCampaignData(res?.data?.campaignData ?? []);
    oldCampaignRef.current = res?.data?.campaignData ?? [];
  };

  const onChange = async (e) => {
    const { name, value, type, checked } = e.target;
    setDataItem({
      ...dataItem,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleCancel = () => {
    navigate(-1);
  }

  const handleCampaignSave = (data) => {
    if (showCampaignPopup.item.hasOwnProperty('index')) {
      const updatedCampaigns = [...campaignData];
      updatedCampaigns[showCampaignPopup.item.index] = data;
      setCampaignData(updatedCampaigns);
    }
    else {
      setCampaignData([...campaignData, data]);
    }
    setShowCampaignPopup({ show: false, item: {} });
  }

  const onCampaignEdit = (item, index) => {
    setShowCampaignPopup({ show: true, item: { ...item, index } });
  }

  const onCampaignDelete = (item, index) => {
    const updatedCampaigns = campaignData.filter((x, i) => i !== index);
    setCampaignData(updatedCampaigns);
  }

  const onPublishOrUnpublish = async (item, index, isPublished) => {
    if (!item?.budget?._id) {
      toast.error('Please save Budget first', { position: toast.POSITION.TOP_RIGHT });
    }
    const oldCampaign = oldCampaignRef.current?.length > 0 ? oldCampaignRef.current?.find(campaign => campaign._id === item._id) : {};

    if (oldCampaign && JSON.stringify(oldCampaign) !== JSON.stringify(item)) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>There are unsaved Changes please save Budget and then try publishing</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return;
    }
    setShowPublishOrUnPublishPopup({ show: true, item: { ...item, index }, isPublished });
  }

  const calculateTotalSpendCap = (campaignData) => {
    return campaignData.reduce((total, campaign) => {
      return total + (parseFloat(campaign.spend_cap) || 0);
    }, 0);
  }

  const isValid = () => {
    if (!dataItem.description || dataItem.description == "") {
      toast.error(lang.please_enter_description_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.clientPONo || dataItem.clientPONo == "") {
      toast.error(lang.please_enter_client_po_no_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.status || Object.keys(dataItem.status).length == 0) {
      toast.error(lang.please_select_status_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.orderDate || dataItem.orderDate == "") {
      toast.error(lang.please_enter_order_date_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.fromDate || dataItem.fromDate == "") {
      toast.error(lang.please_enter_from_date_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.toDate || dataItem.toDate == "") {
      toast.error(lang.please_enter_to_date_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (dataItem.toDate < dataItem.fromDate) {
      toast.error(lang.to_date_cannot_be_earlier_than_from_date_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.agency || Object.keys(dataItem.agency).length == 0) {
      toast.error(lang.please_select_agency_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.client || Object.keys(dataItem.client).length == 0) {
      toast.error(lang.please_select_client_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.currency || Object.keys(dataItem.currency).length == 0) {
      toast.error(lang.please_enter_currency_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (!dataItem.targetAmount || dataItem.targetAmount == 0) {
      toast.error(lang.please_enter_targetAmount_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (dataItem.targetAmount && dataItem.targetAmount < 0) {
      toast.error(lang.please_enter_valid_targetAmount_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    if (campaignData.length > 0 && (calculateTotalSpendCap(campaignData) > parseFloat(dataItem.targetAmount))) {
      toast.error(lang.please_enter_target_amount_error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    return true;
  }

  const saveCampaign = async (budget) => {
    if (campaignData.length === 0) return [];
    let finalData = campaignData.map(x => {
      const { ad_data, ...rest } = x;
      return { ...rest, budget };
    });
    let res = await API.saveData(ENTITYNAME.SM_Campaigns, finalData);
    console.log(res);
    if (!res.success) {
      toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
      return [];
    }
    let data = campaignData.map((x, index) => {
      return { ...x, _id: res?.data?.length > 0 ? res?.data?.[index]?.data?._id ?? null : null };
    });
    return data;
  }

  const saveCampaignAdsLink = async (campaignData) => {
    if (campaignData?.length === 0) return;
    for (const campaign of campaignData) {
      for (const adData of campaign.ad_data) {
        let linkCampaign = await API.getData(ENTITYNAME.SM_CampaignAdsLink, { query: [["campaign_id", "=", campaign?._id], ["ad_id", "=", adData?.ad?._id]] }) ?? [];
        let linkCampaignId = linkCampaign?.data?.length > 0 ? linkCampaign?.data[0]?._id : null;
        await API.saveData(ENTITYNAME.SM_CampaignAdsLink, {
          _id: linkCampaignId,
          status: adData?.status ?? META_STATUS_TYPE.PAUSED,
          audience: adData?.audience,
          start_time: adData?.start_time,
          end_time: adData?.end_time,
          campaign_id: campaign?._id,
          ad_id: adData?.ad?._id,
          daily_budget: campaign?.daily_budget ? parseFloat(campaign?.daily_budget) : 0,
          meta: adData?.meta,
          google: adData?.google,
          linkedin: adData?.linkedin,
          youtube: adData?.youtube,
        })
      }
    }
  }

  const handleSubmit = async (e) => {
    if (!isValid()) return;
    setIsLoading(true)
    let finalData = SocialMediaHelper.saveBudgetEntity(dataItem);
    console.log(finalData)
    const isNew = !finalData._id;
    let res = await API.saveData(ENTITYNAME.SM_Budgets, finalData);
    console.log(res)
    if (res.success) {
      let campaignRes = await saveCampaign({ _id: res?.data?._id, description: res?.data?.description });
      await saveCampaignAdsLink(campaignRes)
      const message = isNew ? 'Budget Saved Successfully' : 'Budget Updated Successfully';
      toast.success(message, { position: toast.POSITION.TOP_RIGHT });
      utility.deleteLocalStorageItem(ENTITYNAME.SM_Budgets);
      if (!id || id == 0) navigate(`/home/smBudgets/${res?.data?._id}`);
      await loadData(res?.data?._id);
    } else {
      toast.error(res.message, { position: toast.POSITION.TOP_RIGHT });
    }
    handleCancel();
    setIsLoading(false);
  };

  const onCreateCampaign = () => {
    if (!isValid()) return
    setShowCampaignPopup({ show: true, item: {} });
  }

  const contentMenuModel = (props) => {
    const menu = [
      {
        label: "Options",
        items: [
          // {label: 'Delete',icon: 'pi pi-trash',command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem,props.dataIndex), () => {})},
          { label: 'Edit', icon: 'pi pi-pencil', command: () => props.onEdit(props.dataItem, props.dataIndex) },
          { label: 'Publish', icon: 'pi pi-arrow-up', command: () => props.onPublish(props.dataItem, props.dataIndex, true) },
          { label: 'Unpublish', icon: 'pi pi-arrow-down', command: () => props.onUnPublish(props.dataItem, props.dataIndex, false) },
          { label: 'Insight', icon: 'pi pi-info-circle', command: () => props.onInsight(props.dataItem) }
        ]
      }
    ]
    return menu;
  }

  const MyCommandCell = (cell) => (
    <MenuCommandCell
      {...cell}
      // onDelete={onCampaignDelete}
      onEdit={onCampaignEdit}
      onPublish={onPublishOrUnpublish}
      onUnPublish={onPublishOrUnpublish}
      onInsight={onInsightClick}
      myMenuModel={contentMenuModel}
    />
  )

  const getDynamicKeys = () => {
    const dynamicKeys = new Set();

    campaignData.forEach(campaign => {
      if (campaign.meta) {
        Object.keys(campaign.meta).forEach(key => dynamicKeys.add(`meta.${key}`));
      }
      if (campaign.google) {
        Object.keys(campaign.google)
          .filter(key => key !== 'googleCampaignId')
          .forEach(key => dynamicKeys.add(`google.${key}`));
      }
    });

    return dynamicKeys;
  };
  const dynamicKeys = getDynamicKeys();

  return (
    <div className='p-2'>
      <EditPageHeader title={lang.budget_dialog_header} onSubmit={handleSubmit} isLoading={isLoading} onCancel={handleCancel} />
      <div className="row mt-2">
        <div className="col-4 form-group">
          <label htmlFor="">{lang.description_label} *</label>
          <input
            type="text"
            className="form-control form-control-sm"
            name="description"
            placeholder="Enter Description"
            value={dataItem.description}
            onChange={onChange}
          />
        </div>
        <div className="col-4 form-group">
          <label htmlFor="clientPONo">{lang.client_po_no_label} *</label>
          <input
            type="text"
            name="clientPONo"
            SID="clientPONo"
            placeholder="Enter Client PO No."
            className="form-control form-control-sm"
            value={dataItem.clientPONo}
            onChange={onChange}
          />
        </div>
        <div className="col-4 form-group">
          <label htmlFor="TabView">{lang.status_label} *</label>
          <DropDownList
            name="status"
            textField="description"
            dataItemKey="_id"
            style={{ backgroundColor: 'white' }}
            data={status}
            value={dataItem.status}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-4 form-group">
          <label htmlFor="orderDate">{lang.order_date_label}</label>
          <input
            type="date"
            SID="orderDate"
            name="orderDate"
            value={dataItem.orderDate}
            onChange={onChange}
            className="form-control form-control-sm"
          />
        </div>
        <div className="col-4 form-group">
          <label htmlFor="fromDate">{lang.from_date_label}</label>
          <input
            type="date"
            SID="fromDate"
            name="fromDate"
            value={dataItem.fromDate}
            onChange={onChange}
            className="form-control form-control-sm"
          />
        </div>
        <div className="col-4 form-group">
          <label htmlFor="toDate">{lang.to_date_label}</label>
          <input
            type="date"
            SID="toDate"
            name="toDate"
            value={dataItem.toDate}
            onChange={onChange}
            className="form-control form-control-sm"
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-4 form-group">
          <label htmlFor="agency">{lang.agency_label} *</label>
          <DropDownList
            name="agency"
            textField="Name"
            dataItemKey="_id"
            style={{ backgroundColor: 'white' }}
            data={agencies}
            value={dataItem.agency}
            onChange={onChange}
          />
        </div>
        <div className="col-4 form-group">
          <label htmlFor="client">{lang.client_label} *</label>
          <DropDownList
            name="client"
            textField="Name"
            dataItemKey="_id"
            style={{ backgroundColor: 'white' }}
            data={clients}
            value={dataItem.client}
            onChange={onChange}
          />
        </div>
        <div className="col-4 form-group">
          <label htmlFor="currency">{lang.currency_label} *</label>
          <DropDownList
            name="currency"
            textField="Description"
            dataItemKey="_id"
            style={{ backgroundColor: 'white' }}
            data={currencies}
            value={dataItem.currency}
            onChange={onChange}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className="col-4 form-group">
          <label htmlFor="targetAmount">{lang.target_amount_label} *</label>
          <input
            type="number"
            name="targetAmount"
            placeholder="Enter Target Amount"
            className={`form-control form-control-sm ${dataItem.targetAmount < calculateTotalSpendCap(campaignData) ? 'border-red-500' : ''}`}
            min={campaignData.length > 0 ? calculateTotalSpendCap(campaignData) : 0}
            value={dataItem.targetAmount}
            onChange={onChange}
          />
        </div>
        <div className="col-4 form-group">
          <div className="flex justify-between items-center">
            <label htmlFor="agencyComission">{lang.agency_commission_label} *</label>
            <span className="float-right" style={{ fontSize: "12px", color: "gray" }}>{lang.can_only_be_in_Percentage}</span>
          </div>
          <input
            type="number"
            name="agencyComission"
            placeholder="Enter Agency Comission"
            value={dataItem.agencyComission}
            onChange={onChange}
            className="form-control form-control-sm"
          />
        </div>
        <div className='col-2'>
          <input
            style={{ border: "1px solid grey", marginTop: "26px" }}
            type="checkbox"
            name="Archive"
            checked={dataItem.Archive}
            onChange={onChange}
          />
          <label className="ml-2">{lang.archive}</label>
        </div>
      </div>
      <div className='row mt-2'>
        <div className="col-12">
          <AddRoundButton name="Create Campaign" onClick={onCreateCampaign} title="Add" icon="plus" />
          <span className='float-right' style={{ marginTop: "15px" }}>Campagins({campaignData?.length ?? 0})</span>

          <Grid resizable style={{ height: "35vh", marginTop: "5px" }} data={campaignData}>
            <Column editable={false} cell={MyCommandCell} width={"50px"} />
            <Column field='name' width="220px" title={lang.campaign_column} />
            <Column field='channel.adType' cell={TextWithIconCell} width="120px" title={lang.channel_column} />
            <Column field='budget.description' width="180px" title={lang.budget_column} />
            <Column field="status" title="Status" width="130px" cell={PublishOrUnPublishStatusCard} />
            {[...dynamicKeys].map((key) => {
              const title = key.split('.').slice(-1)[0].replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
              return (<Column key={key} field={key} title={title} width="165px" />);
            })}
          </Grid>
        </div>
      </div>
      {showCampaignPopup.show && <SMCampaignEditForm onClose={() => setShowCampaignPopup({ show: false, item: {} })} onSave={handleCampaignSave} budgetData={dataItem} item={showCampaignPopup.item} campaignData={campaignData} />}
      {showPublishOrUnPublishPopup.show && <PublishOrUnPublishForm onClose={() => { setShowPublishOrUnPublishPopup({ show: false, item: {} }); loadData() }} item={showPublishOrUnPublishPopup.item} isPublished={showPublishOrUnPublishPopup.isPublished} />}
      {showInsightPopup.show && <SMInsightsForm item={showInsightPopup.item} onClose={() => setShowInsightPopup(false)} />}
    </div>
  );
}

export default SMBudgetEditForm